import React from "react";

interface ToggleControlProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

const ToggleControl: React.FC<ToggleControlProps> = ({ label, checked, onChange, disabled }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginLeft: 0
      }}
    >
      <span
        style={{
          fontFamily: "Inter",
          fontWeight: 500,
          fontSize: "12px",
          lineHeight: "10px",
          color: "rgba(110, 112, 121, 1)",
        }}
      >
        {label}
      </span>

      {/* Custom Toggle */}
      <label className="if-switch-toggle">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled}
        />
        <span className="if-slider-toggle" />
      </label>
    </div>
  );
};

export default ToggleControl;